angular
    .module('digitalLeasing.module')
    .component('contactContractManager', {
        templateUrl: "ng/components/digitalLeasing/checkList/contactContractManager/contactContractManager.view.html",
        bindings: {
            email: "<",
            email2: "<",
            email3: "<",
            mailGestore: '<',
            validateEmail: "&",
            snapshot: "<",
            financialModel: "<"
        },
        controller: ContactContractManagerController,
        controllerAs: "cCMCtrl"
    });

function ContactContractManagerController(
    $configService,
    $portalService,
    $simulationService
) {

    var self = this;

    self.$onInit = function () {

        alternativeEmailCont();
        console.log(self.email, self.email2, self.email3);
    }

    if ($portalService.isAra() && !self.snapshot) {
        self.showAdditionalAddresses = true;
    }

    self.emailChanged = function (mail) {
        switch (mail.name) {

            case "email":
                self.email = mail.value;
                self.validateEmail({ type: mail.name, email: self.email });
                break;
            case "email2":
                self.email2 = mail.value;
                self.validateEmail({ type: mail.name, email: self.email2 });
                break;
            case "email3":
                self.email3 = mail.value;
                self.validateEmail({ type: mail.name, email: self.email3 });
                break;
        }
    }

    var alternativeEmailCont = function () {
        self.waitFromRest = true;
        $simulationService.alternativeEmailContact(self.financialModel)
            .then(function (response) {
                if (response.success) {
                    response.contactList.forEach(function (eMail) {
                        if (!self.mailGestore && eMail.name == 'EMAIL') {
                            self.email = eMail.value
                        }
                        if (eMail.name !== 'EMAIL') {
                            self[eMail.name.toLowerCase()] = eMail.value;
                        }
                        self.validateEmail({ type: eMail.name.toLowerCase(), email: self[eMail.name.toLowerCase()] });
                    })
                }
                self.waitFromRest = false;
            })
    }
}